import { Controller } from "@hotwired/stimulus"
import { markerIcon } from "./base_search_controller"

export default class extends Controller {
  static targets = [ "map", "address" ]

  initialize() {
    this.librariesLoaded = Promise.all([
      google.maps.importLibrary("maps"),
      google.maps.importLibrary("marker")
    ])
  }

  // The map target may be in the markup before the libraries are in (zones editor).
  async mapTargetConnected() {
    await this.librariesLoaded
    this.initMap()
    this.addMarkers()
  }

  initMap() {
    const options = {
      mapId: "3fe2568bfd28a7e1", // TODO: maybe use different id
      disableDefaultUI: true,
      zoomControl: true,
      mapTypeControl: false,
    }

    this.map = new google.maps.Map(this.mapTarget, options)
  }

  addMarkers() {
    if (this.addressTargets.length === 1) {
      const address = this.addressTargets[0];
      const position = {
        lat: parseFloat(address.dataset.lat),
        lng: parseFloat(address.dataset.lng)
      };

      this.addMarker(address);
      const circle = address.dataset.circleRadii
        ? this.addZoneCircles(address, position)
        : this.addCircle(address, position);

      if (circle) {
        this.map.fitBounds(circle.getBounds());
      } else {
        this.map.setCenter(position);
        this.map.setZoom(14);
      }

    } else {
      this.bounds = new google.maps.LatLngBounds()

      this.addressTargets.forEach((address) => {
        this.addMarker(address);

        this.bounds.extend({
          lat: parseFloat(address.dataset.lat),
          lng: parseFloat(address.dataset.lng)
        })
      })

      this.map.fitBounds(this.bounds)
    }
  }

  addMarker(address) {
    new google.maps.marker.AdvancedMarkerElement({
      position: {
        lat: parseFloat(address.dataset.lat),
        lng: parseFloat(address.dataset.lng)
      },
      content: markerIcon(),
      map: this.map,
      title: address.dataset.title
    })
  }

  // Delivery zones: one ring per band, only the outermost is filled. Returns
  // that circle so the map fits on it, like addCircle.
  addZoneCircles(address, position) {
    const radii = JSON.parse(address.dataset.circleRadii)
      .filter((radiusKm) => radiusKm > 0)
      .sort((a, b) => b - a)

    const circles = radii.map((radiusKm, index) => new google.maps.Circle({
      map: this.map,
      center: position,
      radius: radiusKm * 1000,
      clickable: false,
      strokeColor: "#FFFFFF",
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: "#FFD71C",
      fillOpacity: index === 0 ? 0.5 : 0
    }))

    return circles[0] || null
  }

  addCircle(address, position) {
    const radiusKm = parseFloat(address.dataset.circleRadius)
    if (!radiusKm || Number.isNaN(radiusKm)) return null

    return new google.maps.Circle({
      map: this.map,
      center: position,
      radius: radiusKm * 1000,
      strokeColor: "#FFD71C",
      strokeOpacity: 0.8,
      strokeWeight: 1,
      fillColor: "#FFD71C",
      fillOpacity: 0.25
    })
  }
}
